import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import NavMenu from '../navbar/NavMenu';

import Logo from '../../assets/images/logo.svg';



function Header() {

  const location = useLocation().pathname;
  const homeLocation = '/'
  const [hideNav, setHideNav] = useState(false);
  useEffect(() => {
    //console.log(location +"======" + homeLocation)
    //  location === homeLocation ? setHideNav(true) : setHideNav(false)
  });
  return (
    <Navbar collapseOnSelect expand="xl" bg="transparent" data-bs-theme="light">
      <Container>
        <Navbar.Brand href="/"><img src={Logo} /></Navbar.Brand>

        <NavMenu />


        {/* {location.pathname} */}



      </Container>
    </Navbar>
  )
}

export default Header